import SystemtModule from '@/store/SystemModule'
import TenancyRouter from '@/tenancy.router'
import { getModule } from 'vuex-module-decorators'

/** * Central is the subdomain that is the "Landlord" scope */
const CENTRAL = process.env.VUE_APP_CENTRAL_DOMAIN || 'console'
const host = window.location.host.includes(':')
  ? window.location.host.split(':')[0]
  : window.location.host

export default (payload: any) => {
  const force_tenancy_url = process.env?.VUE_APP_FORCE_API_URL || null

  const systemModule = getModule(SystemtModule)

  const is_central = host === CENTRAL

  const protocol = window.location.protocol

  let base = systemModule.api_domain

  const is_dev = process.env.VUE_APP_ENV === 'development'
  if (is_dev && !is_central && !base.includes('8000')) {
    base += `:${process.env.VUE_APP_BACKEND_PORT || '8000'}`
  }

  let tenancy_url: any = `${protocol}//${base}/api/`
  let tenancy_base_url: any = `${protocol}//${base}/`

  /** * Central "Landlord" scope */
  if (force_tenancy_url && force_tenancy_url.length) {
    tenancy_url = force_tenancy_url
  }

  const tenantPermissions = (permissions: any) =>
    permissions.filter((permission: any) => permission.model !== 'tenant')

  return {
    tenantPermissions,
    is_central,
    host,
    tenancy_url,
    tenancy_base_url,
  }
}

export const getTenancyRoutes = ({
  routes = [],
  menus = [],
}: {
  routes?: any[]
  menus?: Array<any>
}) => {
  const is_central = host === CENTRAL

  /** * Central "Landlord" scope */
  if (is_central) {
    routes = TenancyRouter
  }

  if (menus && is_central) {
    menus = menus.filter((menu: any) => ['admin', 'tenants', 'crm'].includes(menu.index))
  }

  if (!is_central) {
    menus = menus.filter((menu: any) => !['tenants'].includes(menu.index))
  }

  const tenantPermissions = (permissions: any) =>
    permissions.filter((permission: any) => permission.model !== 'tenant')

  return {
    tenantPermissions,
    routes,
    menus,
    is_central,
    host,
  }
}
